<script>
import store from '~/store'

export default {
  methods: {
    $can(permissionName) {
      return store.getters.permissions ? store.getters.permissions.indexOf(permissionName) !== -1 : false;
    },
    $checkPermission(permissionName) {
      store.dispatch('fetchUser')

      if (store.getters.permissions.indexOf(permissionName) == -1) {

        store.dispatch('logout')

        return this.$router.push({ name: 'login' })
      };
    }
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/mixins/Permissions.vue